import React from "react";
import { Portal } from "react-portal";

import CloseIcon from "@material-ui/icons/CloseOutlined";

import { IconButton } from "@material-ui/core";

import OutsideClickHandler from "components/OutsideClickHandler";
import Paper from "components/Layout/Paper";

import { Container, PaperContainer, ExitButton, Content } from "./styles";

type Props = {
  children: React.ReactNode;
  onClose: () => void;
  canCloseByOuterClick?: boolean;
  withoutExitButton?: boolean;
};

class Popup extends React.Component<Props> {
  onClickOutside = () => {
    const { canCloseByOuterClick, onClose } = this.props;
    canCloseByOuterClick && onClose();
  };

  render() {
    const { children, onClose, withoutExitButton } = this.props;

    return (
      <Portal>
        <Container>
          <OutsideClickHandler onClick={this.onClickOutside}>
            <PaperContainer>
              <Paper>
                <Content>
                  {!withoutExitButton && (
                    <ExitButton>
                      <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                      </IconButton>
                    </ExitButton>
                  )}
                  {children}
                </Content>
              </Paper>
            </PaperContainer>
          </OutsideClickHandler>
        </Container>
      </Portal>
    );
  }
}

export default Popup;
